import { createContext, useContext } from "react";
import { useQueueProcess } from "./queue-process-hooks";

type ContextQueueProcessType = ReturnType<typeof useQueueProcess>;
export const queueContext = createContext<ContextQueueProcessType | null>(null);

export function useContextQueueProcess() {
  const context = useContext(queueContext);

  if (!context) {
    throw new Error(
      "useContextQueueProcess must be used within a ContextQueueProcessProvider",
    );
  }

  return context;
}

export function ContextQueueProcessProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const queueData = useQueueProcess();

  return (
    <queueContext.Provider value={queueData}>{children}</queueContext.Provider>
  );
}
